// ViewSampleType.jsx
import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewSampleType = ({ sampleType }) => {
  if (!sampleType) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Sample Type Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Sample Type: {sampleType.samtype}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Turn Around: {sampleType.turnaround}
          </Typography>
        </Grid>
        {/* Add additional fields as needed */}
      </Grid>
    </Paper>
  );
};

export default ViewSampleType;
